import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "20",
  fill: "none",
  viewBox: "0 0 14.29 19.31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.61 12.722v6.137a.446.446 0 0 1-.676.383l-3.789-2.274-3.79 2.274a.446.446 0 0 1-.676-.384v-6.135a7.145 7.145 0 1 1 8.932 0zm-4.465-.22a5.358 5.358 0 1 0 0-10.716 5.358 5.358 0 0 0 0 10.717m0-1.786a3.573 3.573 0 1 1 0-7.145 3.573 3.573 0 0 1 0 7.146"
    }, null, -1)
  ])))
}
export default { render: render }